import { post, get } from "../config/axiosConfig.ts";
import { useToast } from "@chakra-ui/react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom"; // If using React Router for navigation
import { TicketContext } from "../context/index.tsx";

export const base64 = (e, setValues) => {
  const file = e.target.files[0];
  const reader = new FileReader();
  reader.addEventListener("load", () => {
    setValues("profilePhoto", reader.result);
  });
  reader.readAsDataURL(file);
};

export const useSignup = (callback) => {
  const { setCheckLogin } = useContext(TicketContext);
  const toast = useToast();

  const submit = async (data, updateOTPForm) => {
    try {
      const result = await post("user/login/register", data);
      toast({
        position: "top",
        title: "Please go and check your E-mail!",
        status: "info",
        isClosable: true,
      });

      const otpKey = result.body;
      updateOTPForm(otpKey);




      // or window.location.reload(); to reload the page
    } catch (error) {
      toast({
        position: "top",
        title: "Something went wrong!",
        status: "error",
        isClosable: true,
      });
      console.log(error);
    }
  };

  const submitOTPStage = async (data) => {
    try {
      const url = `user/login/confirm/key/${data.otpKey}/otp/${data.otp}`;
      const result = await get(url);

      if (result.code !== 200) {
        throw new Error(result.message || "Invalid OTP, please try again.");
      }

      callback();
      setCheckLogin(true);

      toast({
        position: "top",
        title: "Successfully signed up!",
        status: "success",
        duration: 2000,
        isClosable: true,
      });

    } catch (error) {
      throw error; // Pass the error back to onOTPSubmit
    }
  };



  return { submit, submitOTPStage };
};
